import { render } from "./ServiceDashboardContainer.vue?vue&type=template&id=1b0b5292"
import script from "./ServiceDashboardContainer.vue?vue&type=script&lang=js"
export * from "./ServiceDashboardContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__